
export class GetGroupingListRequestModel {
  // グルーピング区分(いばらき)
  public groupingDiv142: string = <string>'';
  // グルーピング区分(とちぎ)
  public groupingDiv163: string = <string>'';
  // グルーピング区分(ぐんま)
  public groupingDiv185: string = <string>'';
  // グルーピング区分(ちば)
  public groupingDiv240: string = <string>'';
  // グルーピング区分(さいたま)
  public groupingDiv210: string = <string>'';
  // グルーピング区分(とうきょう)
  public groupingDiv302: string = <string>'';
  // グルーピング区分(ながの)
  public groupingDiv515: string = <string>'';
  // グルーピング区分(にいがた)
  public groupingDiv451: string = <string>'';
}
